<template>
  <div
    class="flex items-center text-xs font-medium rounded-sm px-1.5 py-1"
    :class="color"
  >
    <div class="rounded-full w-1.5 h-1.5 mr-1" :class="dotColor" />

    <span>{{ name }}</span>
  </div>
</template>
<script setup>
import { computed, defineProps } from "vue";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  priority: {
    required: true,
    type: Object,
  },
});

const name = computed(() => {
  let locale = usePage().props.locale;
  if (locale.includes("_")) {
    locale = locale.split("_")[0];
  }

  return props.priority.translations[locale];
});

const color = computed(() => ({
  "bg-green-50": props.priority.id === "low",
  "text-green-500": props.priority.id === "low",
  "bg-red-50": props.priority.id === "high",
  "text-red-500": props.priority.id === "high",
  "bg-yellow-50": props.priority.id === "normal",
  "text-yellow-500": props.priority.id === "normal",
}));

const dotColor = computed(() => ({
  "bg-green-500": props.priority.id === "low",
  "bg-red-500": props.priority.id === "high",
  "bg-yellow-500": props.priority.id === "normal",
}));
</script>
